export const IconPhone: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_21962_30652)">
      <path
        d="M11.5265 13.8066C11.6986 13.8857 11.8925 13.9037 12.0762 13.8578C12.26 13.8119 12.4226 13.7048 12.5373 13.5541L12.8332 13.1666C12.9884 12.9596 13.1897 12.7916 13.4211 12.6759C13.6526 12.5602 13.9078 12.5 14.1665 12.5H16.6665C17.1085 12.5 17.5325 12.6756 17.845 12.9881C18.1576 13.3007 18.3332 13.7246 18.3332 14.1666V16.6666C18.3332 17.1087 18.1576 17.5326 17.845 17.8451C17.5325 18.1577 17.1085 18.3333 16.6665 18.3333C12.6883 18.3333 8.87295 16.7529 6.0599 13.9399C3.24686 11.1268 1.6665 7.31154 1.6665 3.33329C1.6665 2.89127 1.8421 2.46734 2.15466 2.15478C2.46722 1.84222 2.89114 1.66663 3.33317 1.66663H5.83317C6.2752 1.66663 6.69912 1.84222 7.01168 2.15478C7.32424 2.46734 7.49984 2.89127 7.49984 3.33329V5.83329C7.49984 6.09203 7.4396 6.34722 7.32388 6.57865C7.20817 6.81007 7.04016 7.01138 6.83317 7.16663L6.44317 7.45913C6.29018 7.57594 6.18235 7.74211 6.138 7.92942C6.09364 8.11672 6.11549 8.31361 6.19984 8.48663C7.33874 10.7998 9.21186 12.6706 11.5265 13.8066Z"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_21962_30652">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
